/**
 * Ownership Distribution Chart Component
 * Bar chart showing different ownership types
 */
import React from 'react';
import { Card } from 'antd';
import { Column } from '@ant-design/plots';
import './OwnershipDistribution.css';

const OwnershipDistribution: React.FC = () => {
  const data = [
    { type: 'Sole-Ownership', value: 18 },
    { type: 'Partnership', value: 15 },
    { type: 'Co-operation', value: 8 },
    { type: 'Organization', value: 4 },
  ];

  const config = {
    data,
    xField: 'type',
    yField: 'value',
    color: ({ type }: { type: string }) => {
      const colors: { [key: string]: string } = {
        'Sole-Ownership': '#4caf50',
        'Partnership': '#ff9800',
        'Co-operation': '#f44336',
        'Organization': '#2196f3',
      };
      return colors[type] || '#666';
    },
    columnStyle: {
      radius: [8, 8, 0, 0],
    },
    xAxis: {
      label: {
        style: {
          fill: '#666',
          fontSize: 12,
        },
      },
      grid: {
        line: {
          style: {
            stroke: '#e0e0e0',
            lineDash: [4, 4],
          },
        },
      },
    },
    yAxis: {
      label: {
        style: {
          fill: '#666',
        },
      },
      grid: {
        line: {
          style: {
            stroke: '#e0e0e0',
            lineDash: [4, 4],
          },
        },
      },
      max: 20,
    },
    tooltip: {
      customContent: (title: string, items: any[]) => {
        if (items && items.length > 0) {
          const item = items[0];
          return `
            <div style="padding: 8px; background: white; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
              <div style="font-weight: 600; margin-bottom: 4px;">${title}</div>
              <div style="color: ${item.color};">value : ${item.value}</div>
            </div>
          `;
        }
        return '';
      },
    },
  };

  return (
    <Card className="ownership-distribution-card">
      <div className="chart-title">Ownership Distribution</div>
      <Column {...config} />
    </Card>
  );
};

export default OwnershipDistribution;
